import useTranslation from 'customHooks/translate';

const Tabs = ({ activeTab, setActiveTab }) => {
  const translation = useTranslation();

  return (
    <div className="grid w-full grid-cols-[repeat(auto-fit,minmax(100px,1fr))] items-center rounded-[8px] bg-gray-100 p-[2px] md:flex md:w-fit">
      <button
        onClick={() => setActiveTab('incomes')}
        className={`rounded-[6px] px-[20px] py-[8px] text-[14px] transition-all
        ${
          activeTab === 'incomes' ? 'bg-green-600 text-white' : 'text-[#1D1D1D]'
        }`}
      >
        {translation.reports.Incomes}
      </button>

      <button
        onClick={() => setActiveTab('expenses')}
        className={`rounded-[6px] px-[20px] py-[8px] text-[14px]  transition-all
        ${activeTab === 'expenses' ? 'bg-green-600 text-white' : 'text-black'}`}
      >
        {translation.reports.Expences}
      </button>
    </div>
  );
};

export default Tabs;
